import { createContext, useContext } from 'react';
import type { StaffTokens, StaffUser } from '@/api/types';

export type AuthStatus = 'loading' | 'signedIn' | 'signedOut';

interface AuthContextValue {
  status: AuthStatus;
  staff: StaffUser | null;
  login: (email: string, password: string) => Promise<StaffTokens>;
  acceptInvite: (token: string, name: string, password: string) => Promise<StaffTokens>;
  logout: () => Promise<void>;
  /** Set when the session ended on its own (expired or revoked), not by signing out. */
  expired: boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth outside AuthProvider');
  return ctx;
}

export function useRole() {
  return useAuth().staff?.role;
}
